import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ConsegnaStimata extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDeliveryInfo);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDeliveryInfo);
  }

  updateDeliveryInfo = (event) => {
    // If a new product is loaded (e.g. combined listings), update the data product id
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDelivery = event.detail.data.html.querySelector('consegna-stimata');

    if (!newDelivery) return;

    morph(this, newDelivery, { childrenOnly: true });
  };
}

if (!customElements.get('consegna-stimata')) {
  customElements.define('consegna-stimata', ConsegnaStimata);
}
